import { useContext } from "react";
import {
  RestaurantConfigurationContext,
  type RestaurantConfigurationContextValue,
} from "@/context/RestaurantConfigurationProvider";

export function useRestaurant(): RestaurantConfigurationContextValue {
  const context = useContext(RestaurantConfigurationContext);
  if (!context) {
    throw new Error("useRestaurant must be used within RestaurantConfigurationProvider");
  }
  return context;
}
